import { AuthenticationError } from "@planzone/dto";
import { Gatekeeper } from "../../adapters/gatekeeper";
import { Session } from "../../adapters/session";
import { TokenDecoder } from "../../adapters/tokenDecoder";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(
  gatekeeper: Gatekeeper,
  session: Session,
  tokenDecoder: TokenDecoder,
  repository: Repository,
): Interactor {
  return (credentials) => {
    const error: AuthenticationError = {
      isSessionInvalid: false,
      areCredentialsInvalid: false,
      hasUnExpectedError: false,
      wasSessionNotFound: false,
      message: "",
    };

    return present(
      credentials
        ? gatekeeper
            .authenticate(credentials)
            .then(session.start)
            .then(({ accessToken }) =>
              tokenDecoder
                .decodeToken(accessToken)
                .then((acc) => ({ ...acc, token: accessToken })),
            )
            .then((account) =>
              repository.getUserHumanResource(account).then((resource) => ({
                ...account,
                resource,
              })),
            )
            .catch((e) =>
              session
                .destroy()
                .then(() => Promise.reject({ ...error, ...e }))
                .catch(() => Promise.reject({ ...error, ...e })),
            )
        : session
            .retrieve()
            .then(({ accessToken }) =>
              tokenDecoder
                .decodeToken(accessToken)
                .then((account) =>
                  repository.getUserHumanResource(account).then((resource) => ({
                    ...account,
                    resource,
                    token: accessToken,
                  })),
                )
                .catch(() =>
                  session
                    .destroy()
                    .then(() =>
                      Promise.reject({ ...error, isSessionInvalid: true }),
                    )
                    .catch(() =>
                      Promise.reject({ ...error, isSessionInvalid: true }),
                    ),
                ),
            )
            .catch(() =>
              Promise.reject({
                ...error,
                wasSessionNotFound: true,
              }),
            ),
    );
  };
}

export type { Interactor };

export { createInteractor };
